"use client";

import { useAuth } from "@/context/AuthContext";
import { useEffect, useState } from "react";

export default function DynamicToast() {
    const { toastMessage } = useAuth();
    const [isVisible, setIsVisible] = useState(false);
    const [currentToast, setCurrentToast] = useState(null);
    const [prevToastMessage, setPrevToastMessage] = useState(null);

    if (toastMessage !== prevToastMessage) {
        setPrevToastMessage(toastMessage);
        if (toastMessage) {
            setCurrentToast(toastMessage);
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    }

    useEffect(() => {
        if (toastMessage && toastMessage.type !== 'loading') {
            const duration = toastMessage.duration || 3000;
            const timer = setTimeout(() => setIsVisible(false), Math.max(0, duration - 400)); // Trigger hide animation 400ms before nullified
            return () => clearTimeout(timer);
        }
    }, [toastMessage]);

    if (!toastMessage && !currentToast) return null;

    return (
        <div
            className={`fixed top-8 left-7 right-7 z-9999 transition-all duration-500 ease-[cubic-bezier(0.16,1,0.3,1)] ${isVisible ? "translate-y-0 opacity-100 scale-100 pointer-events-auto" : "-translate-y-12 opacity-0 scale-95 pointer-events-none"
                }`}
        >
            <div className="flex items-center gap-2 px-2 sm:px-4 py-3.5 bg-primary backdrop-blur-lg rounded-2xl shadow-2xl border border-white/10 ring-1 ring-black/5 w-full max-w-none lg:max-w-lg lg:mx-auto relative overflow-hidden">
                {currentToast?.type === 'loading' && currentToast?.progress !== undefined && (
                    <div className="absolute left-0 top-0 bottom-0 bg-white/20 transition-all duration-300" style={{ width: `${currentToast.progress}%` }} />
                )}
                <div className="relative z-10 flex items-center gap-2 w-full">
                    <div className="w-6 h-6 rounded-full bg-primary-light flex items-center justify-center shrink-0">
                        {currentToast?.type === 'loading' ? (
                            <svg className="w-4 h-4 text-primary animate-spin" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                        ) : (
                            <svg className="w-4 h-4 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                            </svg>
                        )}
                    </div>
                    <div className="flex-1 flex items-center justify-between pr-2">
                        <p className="text-sm font-medium text-white tracking-wide leading-relaxed">
                            {currentToast?.message}
                        </p>
                        {currentToast?.type === 'loading' && currentToast?.progress !== undefined && (
                            <span className="text-xs font-bold text-white ml-2">{currentToast.progress}%</span>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
